const REPEAT = {
	NEVER : 0,
	DAILY : 1,
	WEEKLY : 2,
	MONTHLY : 3,
	YEARLY : 4,

	END_NEVER : 0,
	END_ON : 1,
	END_AFTER : 2,

	UPDATE_ALL : 1,
	UPDATE_SINGLE : 2,
	UPDATE_FORWARD : 3
}

class Repeat {

	static fromArray(data, event) {
		let inst = new Repeat(event);

		inst._id = data.shift();
		data.shift();
		inst.frequency = data.shift();
		inst._daysOfWeek = data.shift();
		inst._dayOfMonth = data.shift();
		inst._weekOfMonth = data.shift();
		inst._monthOfYear = data.shift();

		inst.startTime = data.shift() * 1000;
		inst._endDate = data.shift();
		inst._endDate = inst._endDate == null ? Infinity : inst._endDate * 1000;
		
		inst._endType = data.shift();
		//data.shift(); // skip updated
		inst.exceptions = data.shift();

		inst.init();
		return inst;
	}

	static create(event) {
		let inst = new Repeat(event);

		inst.startTime = event._startTime;

		inst.init();
		return inst;
	}

	constructor (event) {
		this._event = event;
		this._startDate;

		this._id = null;
		this._type = REPEAT.NEVER;
		
		this._frequency = 0;
		this._daysOfWeek = null;
		this._dayOfMonth = null;
		this._weekOfMonth = null;
		this._monthOfYear = null;

		this._endDate = Infinity;
		this._endType = REPEAT.END_NEVER;
		this._exceptionDates = [];
		this._exceptionEvents = [];

		this._endOnPicker = new DatePicker('repeat-end-date-picker');
		this._endOnPicker.setHideOnSelect(true);

		this._first = null;
		this._last = null;

		this._form = null;
	}

	init () {
		if (this._monthOfYear !== null) {
			this._type = REPEAT.YEARLY;
		}
		else if (this._dayOfMonth !== null || this._weekOfMonth !== null) {
			this._type = REPEAT.MONTHLY;
		}
		else if (this._daysOfWeek !== null) {
			this._type = REPEAT.WEEKLY;
		}
		else if (this.frequency != 0) {
			this._type = REPEAT.DAILY;
		}
		else {
			this._frequency = 1;
		}
	}

	get form() {
		if (this._form === null) {
			this._weekDayCheckboxes = [];
			let labels = [];

			for (let i = 0; i < 7; i++) {
				let cb = UI.chk();
				cb.disabled = i == this._startDate.getUTCDay();
				this._weekDayCheckboxes.push(cb);
			}
			for (let i = 1; i <=7; i++) {
				labels.push(
					UI.label([
						this._weekDayCheckboxes[i%7], UI.span('px-1', App.WKD[i%7])
					])
				);
			}

			this._weekDayInputRow = UI.div('flex my-3 items-center justify-around flex-row', labels);
		
			this._form = UI.div('p-4', [
				UI.div('flex gap-2 items-center', [
					UI.div('w-1/4 shrink-0 text-end', _("Repeat")),
					UI.div('flex-1', this._typeSelect = UI.select([
							UI.option("Never", REPEAT.NEVER),
							UI.option("Daily", REPEAT.DAILY),
							UI.option("Weekly", REPEAT.WEEKLY),
							UI.option("Monthly", REPEAT.MONTHLY),
							UI.option("Yearly", REPEAT.YEARLY)
						], {'change': this.onTypeChange.bind(this)})
					),
				]),
				this._details = UI.div(null, [
					UI.div('flex gap-2 items-center my-2', [
						UI.div('w-1/4 shrink-0 text-end', "Every"),
						UI.div('flex-1 flex gap-2 items-center', [
							this._frequencyInput = UI.input('number', 'ed-text'),
							this._frequencyDesc = UI.span(),
						]),
					]),
					this._weekDayInputRow,
					UI.div('flex gap-2 items-center my-2', [
						UI.div('w-1/4 shrink-0'),
						UI.div('flex-1', this._monthSelect = UI.select())
					]),
					UI.div('flex gap-2 items-center my-2', [
						UI.div('w-1/4 shrink-0 text-end', "Ends"),
						UI.div('flex-1', this._endTypeSelect = UI.select([
							UI.option("Never", REPEAT.END_NEVER),
							UI.option("On", REPEAT.END_ON),
							UI.option("After", REPEAT.END_AFTER)
						], {'change': this.update.bind(this)})),
					]),
					UI.div('flex gap-2 items-center my-2', [
						UI.div('w-1/4 shrink-0'),
						UI.div('flex-1 flex gap-2 items-center', [
							this._endOnPicker.getInputElem(),
							this._endAfterInput = UI.input('number', 'ed-text', null, {
								'keydown': this.numbersOnly.bind(this)
							})
						])
					])
				])
			]);

			this._typeSelect.value = this._type;
			this._frequencyInput.value = this._frequency;
			if (this._daysOfWeek == null) {
				this._weekDayCheckboxes[this._startDate.getUTCDay()].checked = true;
			}
			else {
				for (let i = 0; i < 7; i++) {
					this._weekDayCheckboxes[i].checked = this._daysOfWeek & (1 << i);
				}
			}
			
			if (this._id == null) {
				this._endOnPicker.setDate(
					Date.UTC(
						this._startDate.getUTCFullYear(), 
						this._startDate.getUTCMonth(), 
						this._startDate.getUTCDate() + 4
					)
				);
			} else if (this.endType == REPEAT.END_NEVER) {
				let now = new Date();
				this._endOnPicker.setDate(
					Date.UTC(
						now.getFullYear(), 
						now.getMonth(), 
						now.getDate() + 4
					)
				);
			} else {
				this._endOnPicker.setDate(this._endDate);
			}
			this.calculateEndAfter();
			this.updateMonthOptions();
			this._monthSelect.value = this._weekOfMonth == null ? 0 : this._weekOfMonth;
			this._endTypeSelect.value = this._endType;
			this.update();
		}
		return this._form;
	}

	set startTime(value) {
		if (!(value instanceof Date)) {
			value = new Date(value);
		}
		value.setUTCHours(0,0,0,0);
		let diff = false;
		if (this._startDate) {
			this.clearExceptions();
			if (value != this._startDate) {
				this.disposeForm();
				diff = value - this._startDate;
				if (this.endType == REPEAT.END_AFTER) {
					this._endDate += diff;
				}
				diff = diff/86400000;
				if (this._daysOfWeek != null) {
					if (diff > 0) {
						for (let i = 0; i < Math.abs(diff)%7; i++){
							this._daysOfWeek = this._daysOfWeek<<1;
							if (this._daysOfWeek & 128) this._daysOfWeek -= 127;
						}
					}
					else if (diff < 0) {
						for (let i = 0; i < Math.abs(diff%7); i++) {
							if (this._daysOfWeek & 1) this._daysOfWeek += 127;
							this._daysOfWeek = this._daysOfWeek>>>1;
						}
					}
				}
				
				if (this._dayOfMonth != null) {
					this._dayOfMonth = value.getUTCDate();
				}
				if (this._weekOfMonth != null) {
					this._weekOfMonth = Math.ceil(value.getUTCDate() / 7);
				}
				if (this._monthOfYear != null) {
					this._monthOfYear = value.getUTCMonth();
				}
			}
		}
		this._startDate = value;
	}

	get startTime() {
		return this._startDate.getTime();
	}

	get endType() {
		return this._endType;
	}

	get frequency() {
		return this._frequency;
	}

	set frequency(value) {
		if (value == null) value = 0;
		this._frequency = value;
	}

	set endType(value) {
		this._endType = value;
	}

	set exceptions(data) {
		if (Array.isArray(data) && data.length) {
			data.forEach(part => {
				this._exceptionDates.push(part[0]);
				this._exceptionEvents.push(part[1]);
			});
		}
	} 

	copy(newEvent, originStartTime) {
		originStartTime = new Date(originStartTime);
		originStartTime.setUTCHours(0,0,0,0);

		let inst = new Repeat(newEvent);

		inst._type = this._type;
		inst._frequency = this._frequency;
		inst._daysOfWeek = this._daysOfWeek;
		inst._dayOfMonth = this._dayOfMonth;
		inst._weekOfMonth = this._weekOfMonth;
		inst._monthOfYear = this._monthOfYear;

		inst._startDate = originStartTime;
		inst._endDate = this._endDate;
		inst._endType = this._endType;

		inst.startTime = newEvent._startTime;
		return inst;
	}

	updateMonthOptions() {
		this._monthSelect.innerHTML = '';

		let week = Math.ceil(this._startDate.getUTCDate() / 7);
		let of 
			= this._typeSelect.value == REPEAT.MONTHLY 
			? _(" of the month")
			: _(" of ") + App.MONTH[this._startDate.getUTCMonth()];
		
		this._monthSelect.appendChild(
			UI.option(_("On the ") + numSuffix(this._startDate.getUTCDate()) + of, 0)
		);
		if (week < 5) {
			this._monthSelect.appendChild(
				UI.option(_("On the ") + numSuffix(week) + ' ' + App.WEEKDAY[this._startDate.getUTCDay()] + of, week)
			);
		}
		if (week > 3) {
			this._monthSelect.appendChild(
				UI.option(_("On the last ") + App.WEEKDAY[this._startDate.getUTCDay()] + of, 5)
			);
		}
	}

	apply() {
		this._type = parseInt(this._typeSelect.value);
		this._frequency = this._frequencyInput.value;

		if (this._type == REPEAT.NEVER) {
			this.delete();
			return;
		}

		if (this._type == REPEAT.WEEKLY) {
			this._daysOfWeek = 0;
			for (let i = 0; i < 7; i++) {
				if (this._weekDayCheckboxes[i].checked) {
					this._daysOfWeek += 1 << i;
				}
			}
		} else {
			this._daysOfWeek = null;
		}

		if (this._type == REPEAT.MONTHLY || this._type == REPEAT.YEARLY) {
			this._dayOfMonth = this._monthSelect.value == 0 ? this._startDate.getUTCDate() : null;
			this._weekOfMonth = this._monthSelect.value == 0 ? null : parseInt(this._monthSelect.value);
			this._monthOfYear = this._type == REPEAT.YEARLY ? this._startDate.getUTCMonth() : null;
		} else {
			this._dayOfMonth = null;
			this._weekOfMonth = null;
			this._monthOfYear = null;
		}

		this._endType = parseInt(this._endTypeSelect.value);

		if (this._endType == REPEAT.END_ON) {
			this._endDate = this._endOnPicker.getUTC();
		} else if (this._endType == REPEAT.END_AFTER) {
			this.calculateEndOn();
		} else {
			this._endDate = Infinity;
		}

		this._event.rebuild();
		this.save();
	}

	save() {
		API.upsert('repeats', this._id, {
			'eventId': this._event.id,
			'freq': this._frequency,
			'dayOfWeek': this._daysOfWeek,
			'dayOfMonth': this._dayOfMonth,
			'weekOfMonth': this._weekOfMonth,
			'monthOfYear': this._monthOfYear,
			'startDate': this._startDate.getTime()/1000,
			'endDate': this._endDate == Infinity ? null : this._endDate/1000,
			'endType': this._endType
		})
		.then(data => this.saveCallback(data));
	}

	saveCallback(reply) {
		if (reply.id) {
			this._id = reply.id;
		}
	}

	cancel() {
		this.disposeForm();
		if (!this._id) this.delete();
	}

	delete() {
		this._event._repeat = null;
		this._event.rebuild();
		if (!this._id) return;

		API.delete('repeats/'+this._id)
		.then(data => showError(data));
	}

	disposeForm() {
		if (this._form == null) return;
		this._form.remove();
		this._form = null;
	}

	isException(time) {
		if (!Array.isArray(this._exceptionDates) || this._exceptionDates.length == 0) return false;
		return this._exceptionDates.indexOf(time/1000) !== -1;
	}

	get first() {
		let time = this.startTime;
		while (this.isException(time)) {
			time = this.getNext(time);
			if (!time) return false;
		}
		return time;
	}

	jumpTo(targetTime) {
		if (this._frequency < 1) return false;
		if (targetTime <= this.startTime) return this.first;
		if (targetTime >= this._endDate) return false;

		const MS_PER_DAY = 86400000;
		let result;

		if (this._type == REPEAT.DAILY) {
			let daysSinceStart = Math.floor((targetTime - this.startTime) / MS_PER_DAY);
			let periods = Math.floor(daysSinceStart / this._frequency);
			result = this.startTime + periods * this._frequency * MS_PER_DAY;
		}
		else if (this._type == REPEAT.WEEKLY) {
			let daysSinceStart = Math.floor((targetTime - this.startTime) / MS_PER_DAY);
			let weeksSinceStart = Math.floor(daysSinceStart / 7);
			let cycleWeeks = weeksSinceStart - (weeksSinceStart % this._frequency);
			let cycleStart = this.startTime + cycleWeeks * 7 * MS_PER_DAY;

			let best = false;
			for (let d = 0; d < 7 * this._frequency; d++) {
				let candidate = cycleStart + d * MS_PER_DAY;
				if (candidate > targetTime) break;
				let dt = new Date(candidate);
				if (this._daysOfWeek !== null && (1 << dt.getUTCDay() & this._daysOfWeek)) {
					best = candidate;
				}
			}
			if (best !== false) {
				result = best;
			} else {
				cycleStart -= this._frequency * 7 * MS_PER_DAY;
				if (cycleStart < this.startTime) return this.first;
				for (let d = 7 * this._frequency - 1; d >= 0; d--) {
					let candidate = cycleStart + d * MS_PER_DAY;
					let dt = new Date(candidate);
					if (this._daysOfWeek !== null && (1 << dt.getUTCDay() & this._daysOfWeek)) {
						result = candidate;
						break;
					}
				}
				if (result === undefined) return this.first;
			}
		}
		else if (this._type == REPEAT.MONTHLY) {
			let sd = this._startDate;
			let td = new Date(targetTime);
			let monthsSinceStart = (td.getUTCFullYear() - sd.getUTCFullYear()) * 12
				+ (td.getUTCMonth() - sd.getUTCMonth());
			let periods = Math.floor(monthsSinceStart / this._frequency);
			let jumpMonths = periods * this._frequency;
			let month = sd.getUTCMonth() + jumpMonths;
			let year = sd.getUTCFullYear();
			while (month > 11) { month -= 12; year++; }
			result = Date.UTC(year, month, this.date(year, month));
			if (result > targetTime && periods > 0) {
				jumpMonths = (periods - 1) * this._frequency;
				month = sd.getUTCMonth() + jumpMonths;
				year = sd.getUTCFullYear();
				while (month > 11) { month -= 12; year++; }
				result = Date.UTC(year, month, this.date(year, month));
			}
		}
		else if (this._type == REPEAT.YEARLY) {
			let sd = this._startDate;
			let td = new Date(targetTime);
			let yearsSinceStart = td.getUTCFullYear() - sd.getUTCFullYear();
			let periods = Math.floor(yearsSinceStart / this._frequency);
			let year = sd.getUTCFullYear() + periods * this._frequency;
			let month = sd.getUTCMonth();
			result = Date.UTC(year, month, this.date(year, month));
			if (result > targetTime && periods > 0) {
				year = sd.getUTCFullYear() + (periods - 1) * this._frequency;
				result = Date.UTC(year, month, this.date(year, month));
			}
		}
		else {
			return this.first;
		}

		if (result < this.startTime) result = this.startTime;

		let guard = 0;
		while (this.isException(result) && guard++ < 50) {
			result = this.getNext(result);
			if (!result) return false;
		}

		if (result >= this._endDate) return false;
		return result;
	}

	getPrev(time) {
		let loopCheck = 999;
		do {
			time = this.adjust(time, -1);
		} while (this.isException(time) && loopCheck--)
		if (!loopCheck) console.log('loop overrun - repeat getPrev');
		if (time < this._startDate) return false;
		return time;
	}
	
	getNext(time) {
		let loopCheck = 999;
		do {
			time = this.adjust(time, 1);
		} while (this.isException(time) && loopCheck--)
		if (!loopCheck) console.log('loop overrun - repeat getNext');
		if (this._endDate < time) return false;
		return time;
	}

	adjust (refTime, direction) {
		let referenceDate = new Date(refTime);
		if (this._type == REPEAT.WEEKLY) {
			let skips = this._frequency - 1;
			while (referenceDate.setUTCDate(referenceDate.getUTCDate() + direction)){
				if (referenceDate.getUTCDay() == 0 && skips !== 0) {
					referenceDate.setUTCDate(referenceDate.getUTCDate() + 7 * skips * direction);
				}
				if (1 << referenceDate.getUTCDay() & this._daysOfWeek) break;
			}
			return Date.UTC(
				referenceDate.getUTCFullYear(),
				referenceDate.getUTCMonth(),
				referenceDate.getUTCDate()
			);
		}
		if (this._type == REPEAT.MONTHLY) {
			let month = referenceDate.getUTCMonth() + this._frequency * direction;
			let year = referenceDate.getUTCFullYear();
			while (month < 0) { month += 12; year--; }
			while (11 < month) { month -= 12; year++; }

			return Date.UTC(
				year,
				month,
				this.date(year, month)
			);
		}
		if (this._type == REPEAT.YEARLY) {
			let month = referenceDate.getUTCMonth();
			let year = referenceDate.getUTCFullYear() + this._frequency * direction;

			return Date.UTC(
				year,
				month,
				this.date(year, month)
			);
		}
		return Date.UTC(
			referenceDate.getUTCFullYear(),
			referenceDate.getUTCMonth(),
			referenceDate.getUTCDate() + this._frequency * direction
		);
	}

	date(year, month) {
		if (this._dayOfMonth !== null) {
			return Math.min(this._dayOfMonth, daysInMonth(year, month));
		}

		let firstOfMonth = new Date(Date.UTC(year, month));
		// first occurrence of weekday
		let date = (this._startDate.getUTCDay() - firstOfMonth.getUTCDay() + 7) % 7 + 1;
		// add number of weeks
		date += (this._weekOfMonth - 1) * 7;
		// rollback if outside month
		while (daysInMonth(year, month) < date) {date -= 7;}

		return date;
	}

	getArray() {
		return [
			this._id,
			this._frequency,
			this._daysOfWeek,
			this._dayOfMonth,
			this._weekOfMonth,
			this._monthOfYear,
			this._endDate == null ? null : this._endDate,
			this._endType
		];
	}

	numbersOnly(ev) {
		let kc = ev.keyCode;
		let ok = [8, 46, 37, 39, 13, 27];
		for (let i = 0; i < ok.length; i++)
			if (kc === ok[i]) return;
		if (kc < 48 || kc > 57)
			ev.preventDefault();
	}

	calculateEndOn() {
		this._endDate = Infinity;
		let refTime = this._startDate.getTime();
		let i = this._endAfterInput.value - 1;
		while (i--) refTime = this.adjust(refTime, 1);
		this._endDate = refTime;
	}

	calculateEndAfter() {
		let refTime = this._startDate.getTime();
		let stop = this._endOnPicker.getUTC();

		this._endAfterInput.value = 0;
		let loopCheck = 9999;
		while (refTime <= stop && loopCheck--) {
			refTime = this.adjust(refTime, 1);
			this._endAfterInput.value++;
		}
		if (!loopCheck) console.log('loop overrun - repeat calculateEndAfter');
	}

	onTypeChange() {
		this.updateMonthOptions();
		this.update();
	}

	trim(date) {
		date = new Date(date);
		date.setUTCDate(date.getUTCDate() -1);
		date.setUTCHours(0,0,0,0);
		this._endDate = date.getTime();
		this._endType = REPEAT.END_ON;
		this.save();
	}

	makeException(date, tlEvent) {
		date = new Date(date);
		date.setUTCHours (0,0,0,0);
		let seconds = date.getTime() / 1000;
		this._exceptionDates.push(seconds);
		this._exceptionEvents.push(tlEvent);
		saveManager.queue(this, 'saveException');
	}

	saveException() {
		for (let i = 0; i < this._exceptionDates.length; i++) {
			let event = this._exceptionEvents[i];
			if (event instanceof TimelineEvent || event === null) {
				let eventId = event == null ? 0 : event.id;
				this._exceptionEvents[i] = eventId;
				
				API.insert('repeats/'+this._id+'/exceptions', {
					exceptionDate: this._exceptionDates[i],
					exceptionEvent: eventId
				})
				.then(saveManager.nudge());
				return;
			}
		}
	}

	clearExceptions() {
		if (this._exceptionDates.length == 0) return;
		this._exceptionEvents.forEach(
			eventId => {
				globalTimeline.removeEvent(globalTimeline.findEvent(eventId));
			}
		);
		this._exceptionDates = [];
		this._exceptionEvents = [];
		API.delete('repeats/'+this._id+'/exceptions');
	}

	update() {
		let descriptors = ['', ' day', ' week', ' month', ' year'];

		this._details.style.display = this._typeSelect.value == REPEAT.NEVER ? 'none' : 'block';
		this._frequencyDesc.innerHTML =
		descriptors[this._typeSelect.value] + (1 < this._frequencyInput.value ? 's' : '');


		this._weekDayInputRow.style.display = this._typeSelect.value == REPEAT.WEEKLY ? 'flex' : 'none';
		this._monthSelect.style.display 
			= this._typeSelect.value == REPEAT.MONTHLY
			|| this._typeSelect.value == REPEAT.YEARLY
			? 'block' 
			: 'none';
		this._endOnPicker.getInputElem().style.display = this._endTypeSelect.value == REPEAT.END_ON ? 'inline-block' : 'none';
		this._endAfterInput.style.display = this._endTypeSelect.value == REPEAT.END_AFTER ? 'inline-block' : 'none';

	}
}